import Lenis from "lenis";

const store = { instance: null };

export function initLenis() {
  if (store.instance) return store.instance;
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReduced) return null;
  const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  window.__lenis = lenis;
  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
  store.instance = lenis;
  return lenis;
}

export function scrollToHash(hash) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (store.instance) {
    store.instance.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export function scrollTop(immediate = true) {
  if (store.instance) {
    store.instance.scrollTo(0, { immediate });
  } else {
    window.scrollTo(0, 0);
  }
}
